/* eslint-disable @typescript-eslint/naming-convention */
export const PusherConfig = {
  Dispensary: {
    CHANNEL: (dispensaryId: string) => `private-curbside-arrivals-user-${dispensaryId}`,
    Events: {
      CURBSIDE_ARRIVAL_ARRIVED: 'curbside-arrival-arrived',
      CURBSIDE_ARRIVAL_CLEARED_ALL: 'curbside-arrival-cleared-all',
      CURBSIDE_ARRIVAL_CLEARED: 'curbside-arrival-cleared',
      CURBSIDE_ARRIVAL_UPDATED: 'curbside-arrival-updated',
    },
  },
  DispensaryOrders: {
    CHANNEL: ({ id }: { id: string }) => `dispensary-${id}-orders`,
    Events: {
      ORDER_UPDATED: 'order-updated',
    },
  },
  Order: {
    CHANNEL: (orderId: string) => `order-${orderId}`,
    Events: {
      ORDER_UPDATED: 'order-updated',
    },
  },
  PrivateOrder: {
    CHANNEL: (orderId: string) => `private-order-${orderId}`,
    Events: {
      ORDER_PRINTED: 'client-order-printed',
    },
  },
  PersistentRequests: {
    CHANNEL: ({ id }: { id: string }) => `persistent-requests-session-${id}`,
    Events: {
      RESOLVED: 'persistent-request-resolved',
    },
  },
  PublicContextSession: {
    CHANNEL: (sessionId: string) => `public-context-session-${sessionId}`,
    Events: {
      SESSION_UPDATED: 'session-updated',
      LOGIN_METHOD_VERIFIED: 'login-method-verified',
      SESSION_CLAIMED: 'session-claimed',
      SESSION_EXPIRED: 'session-expired',
    },
  },
  Terminal: {
    CHANNEL: ({ deviceId }: { deviceId: string }) => `private-terminal-${deviceId}`,
    Events: {
      PRINT: 'print-from-commands',
    },
  },
  Consumer: {
    CHANNEL: 'consumer-general',
    Events: {
      ReloadApp: 'reload-app',
    },
  },
  Admin: {
    CHANNEL: 'admin-general',
    Events: {
      ReloadApp: 'reload-app',
    },
  },
  ContentCleanup: {
    CHANNEL: 'presence-content-cleanup-tool',
    Events: {
      SUBSCRIPTION_ERROR: 'pusher:subscription_error',
      SUBSCRIPTION_SUCCEEDED: 'pusher:subscription_succeeded',
    },
  },
  Buckets: {
    CHANNEL: 'buckets',
    Events: {
      CREATED: 'created',
      DESTROYED: 'destroyed',
      UPDATED: 'updated',
    },
  },
  DeviceConnections: {
    Events: {
      sendConnectionToken: 'SEND_CONNECTION_TOKEN',
      connectionFinalized: 'CONNECTION_FINALIZED',
    },
  },
  InstoreCart: {
    CHANNEL: (orderId: string) => `dutchie-instore-cart-${orderId}`,
    EVENTS: {
      INSTORE_CART_LOADED: 'cart_loaded',
    },
  },
  AeroSyncPreAuth: {
    CHANNEL: (channelName: string) => channelName,
    EVENTS: {
      PRE_AUTH_STATUS_CHANGE: 'status_change',
    },
  },
};
